export interface AuthorizationPermission {
    product: string;
    applicationInstance: string;
    permissions: string[];
    organizationId: number;
    agbCode: string;
    cicCode: number;
    mrdmUri: string;
    clientId: number;
    ziekenhuisCode: number;
    name: string;
    position: string;
}

export interface AuthorizationProfile {
    accountId: number;
    email: string;
    firstName: string;
    lastName: string;
    organizations: AuthorizationOrganization[];
    isDisabled: boolean;
    isInternal: boolean;
    metadata?: Record<string, string>;
    impersonation?: ImpersonationInfo;
}

export interface AuthorizationOrganization {
    OrganizationId: number;
    AgbCode: string;
    CicCode: number;
    MrdmUri: string;
    ClientId: number;
    ZiekenhuisCode: number;
    Name: string;
    Position: string;
}

export interface ImpersonationInfo {
    originalUserName: string;
    originalUserEmail: string;
}
